import React from 'react';
import { Paper, Grid, Typography, MenuItem, Checkbox } from 'material-ui';
import TextField from 'material-ui/TextField/TextField';
import { withStyles } from 'material-ui/styles/index'; // only needs to be imported once
import { translate } from 'react-i18next';
import ObservationsChecksRender from './ObservationsChecksRender';
import { DialogContent } from 'material-ui';

const styles = theme => ({
    clientRowTitle: {
        fontSize: '14px',
        fontWeight: 600,
    },
    clientRowValue: {
        fontSize: '14px',
        fontWeight: 300,
    },
    expandIcon: {
        color: theme.palette.primary.main
    },
    bookingTitle: {
        color: theme.palette.primary.main,
        padding: '20px 0 20px 25px',
        fontWeight: 'bold',
        fontSize: '1.2rem',
        borderLeft: '2px solid ' + theme.palette.primary.main
    },
    paperFrame: {
        margin: '40px 0px'
    }
});



function CommentsControl(props) {
    const { t } = props;
    return (
        <DialogContent className="dialog-observations">
            <TextField
                fullWidth
                className="dialog-input-observations"
                multiline={true}
                margin="normal"
                rows="4"
                label={props.reservation && props.reservation.type === 'Hotel' ?
                    t('CONFIRM_BOOKING.HOTEL_OBSERVATIONS') :
                    t('CONFIRM_BOOKING.COMMENTS')}
                required={false}
                value={props.reservation ? props.reservation.clientObservations : ''}
                placeholder={t('CONFIRM_BOOKING.INSERT_OBSERVATIONS')}
                InputLabelProps={{
                    shrink: true,
                }}
                onChange={event => {
                    if (props.onChangeObservations) {
                        props.onChangeObservations(String(event.target.value));
                    }
                }}
            />
        </DialogContent>
    );
}

function AgencyLocatorControl(props) {
    const { t } = props;

    return (
        <TextField
            fullWidth
            label={t('CONFIRM_BOOKING.AGENCY_LOCATOR')}
            InputLabelProps={{
                shrink: true,
            }}
            placeholder={t('CONFIRM_BOOKING.INSERT_LOCATOR')}
            required={true}
            value={props.reservation ? props.reservation.clientLocator : ''}
            error={props.clientLocatorError}
            onChange={event => {
                if (props.onChangeClientLocator) {
                    props.onChangeClientLocator(String(event.target.value));
                }
            }}
        />
    );
}

function NameControl(props) {
    const { t } = props;
    return (
        <TextField
            fullWidth
            label={t('CONFIRM_BOOKING.NAME')}
            required={true}
            value={props.reservation ? props.reservation.holder.name : ''}
            placeholder={t('CONFIRM_BOOKING.INSERT_CLIENTE_NAME')}
            error={props.error}
            InputLabelProps={{
                shrink: true,
            }}
            onChange={event => {
                if (props.onChange) {
                    props.onChange(String(event.target.value), 'name');
                }
            }}
        />
    );
}

function LastNameControl(props) {
    const { t } = props;
    return (
        <TextField
            fullWidth
            label={t('CONFIRM_BOOKING.LASTNAMES')}
            InputLabelProps={{
                shrink: true,
            }}
            placeholder={t('CONFIRM_BOOKING.INSERT_CLIENT_LASTNAME')}
            required={true}
            value={props.reservation ? props.reservation.holder.lastname : ''}
            error={props.error}
            onChange={event => {
                if (props.onChange) {
                    props.onChange(String(event.target.value), 'lastname');
                }
            }}
        />
    );
}

function Document(props) {
    const { t } = props;
    return (
        <TextField
            fullWidth
            label={t('CONFIRM_BOOKING.DOCUMENT')}
            InputLabelProps={{
                shrink: true
            }}
            placeholder={t('CONFIRM_BOOKING.INSERT_DOCUMENT')}
            required={true}
            value={props.reservation ? props.reservation.holder.document : ''}
            error={props.error}
            onChange={event => {
                if (props.onChange) {
                    props.onChange(String(event.target.value), 'document');
                }
            }}
        />
    );
}

function DocumentIdType(props) {
    const { t } = props;
    const types = [
        { value: 'CIF', name: t('CONFIRM_BOOKING.CIF') },
        { value: 'NIF', name: t('CONFIRM_BOOKING.NIF') },
        { value: 'NIE', name: t('CONFIRM_BOOKING.NIE') },
        { value: 'Pas', name: t('CONFIRM_BOOKING.PASSPORT') }
    ];
    return (
        <TextField
            select
            label={t('CONFIRM_BOOKING.DOCUMENT_TYPE')}
            InputLabelProps={{
                shrink: true,
            }}
            required={true}
            value={props.reservation && props.reservation.holder && props.reservation.holder.documentType ? props.reservation.holder.documentType : 'none'}
            error={props.error}
            fullWidth
            onChange={event => {
                if (props.onChange) {
                    props.onChange(String(event.target.value), 'documentType');
                }
            }}>
            <MenuItem key="none" value="none" style={{ fontWeight: 300 }}>
                {t('CONFIRM_BOOKING.INSERT_DOCUMENT_TYPE')}
            </MenuItem>
            {types.map(option => (
                <MenuItem key={option.value} value={option.value}>
                    {option.name}
                </MenuItem>
            ))}
        </TextField>
    );
}

function InformationForm(props) {
    const { reservation, checks } = props;
    return (
        <React.Fragment>
            <Grid item xs={12}>
                <AgencyLocatorControl {...props} />
            </Grid>

            <Grid container item wrap="nowrap" spacing={8}>
                <Grid item xs={6}>
                    <NameControl {...props} />
                </Grid>
                <Grid item xs={6}>
                    <LastNameControl {...props} />
                </Grid>
            </Grid>
            {reservation && reservation.cancellationInsurance && reservation.cancellationInsurance.active === 'SI' && reservation.cancellationInsuranceAcepted &&
                <Grid container item wrap="nowrap" spacing={8}>
                    <Grid item xs={6}>
                        <DocumentIdType {...props} />
                    </Grid>
                    <Grid item xs={6}>
                        <Document {...props} />
                    </Grid>
                </Grid>
            }
            <Grid item xs={12}>
                <div className="checks-confirm-view">
                    {checks && checks.length &&
                        <React.Fragment>
                            <Typography className="hotel-observations-title">
                                {props.t('CONFIRM_BOOKING.HOTEL_ITEMS_OBSERVATIONS')}
                            </Typography>
                            <ObservationsChecksRender {...props} />
                        </React.Fragment>
                    }
                    <CommentsControl {...props} />
                </div>
            </Grid>

        </React.Fragment>
    );
}

class ReservationHolderRender extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { viewOnlyMode, classes, t } = this.props;
        return (
            <Paper className={'paperFrame'} id="themainformpaper">
                <Typography className={classes.bookingTitle}>
                    {t('BOOKING_DETAIL.CLIENT_DETAIL')}
                </Typography>
                {viewOnlyMode ? (
                    <Grid container>
                        <Grid container item xs={12}>
                            <Typography className={classes.clientRowTitle}>
                                {t('BOOKING_DETAIL.LOCATOR')}
                            </Typography>
                            <Typography className={classes.clientRowValue}>
                                {this.props.reservation ? this.props.reservation.clientLocator : ''}
                            </Typography>
                        </Grid>
                        <Grid container item xs={12}>
                            <Typography className={classes.clientRowTitle}>
                                {t('BOOKING_DETAIL.NAME')}
                            </Typography>
                            <Typography className={classes.clientRowValue}>
                                {this.props.reservation && this.props.reservation.holder
                                    ? `${this.props.reservation.holder.name} ${
                                    this.props.reservation.holder.lastname
                                    }`
                                    : ''}
                            </Typography>
                        </Grid>
                    </Grid>
                ) : (

                        <Grid container className="formContainer">

                            <InformationForm {...this.props} />
                            <Typography>
                                {t('CONFIRM_BOOKING.SPECIAL_REQUESTS')}
                            </Typography>

                            <Grid item xs={12}>
                                <Typography
                                    style={{
                                        marginTop: '8px',
                                        fontWeight: 300,
                                        marginBottom: '-8px',
                                    }}
                                    variant={'caption'}>
                                    {t('CONFIRM_BOOKING.REQUIRED_FIELDS')}
                                </Typography>
                            </Grid>
                        </Grid>
                    )}
            </Paper>
        );
    }
}
export default translate('translations')(withStyles(styles)(ReservationHolderRender));



// WEBPACK FOOTER //
// ./src/components/Reservation/ReservationHolderRender.js